<template>
  <div class="inner-box">
    <el-form size="small">
      <div class="content-name">
        <h2 class="dp-ib">월별수불현황</h2>
        <el-form-item label-width="0px" style="float: right;">
          <el-button type="primary" icon="el-icon-search" @click="goOpen">{{ this.$i18n.messages[this.$store.state.locale].search }}</el-button>
        </el-form-item>
      </div>
    </el-form>
    <!-- 검색조건 영역 -->
    <div class="search-form">
      <el-form size="mini" label-width="80px">
        <el-row style="margin-bottom: 0px;">
          <el-col :span="6">
            <el-form-item label="기준년월" label-width="100px">
              <el-col :span="12">
                <el-select v-model="form.years">
                  <el-option
                      v-for="item in combos['years']"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="12">
                <el-select v-model="form.months">
                  <el-option
                      v-for="item in combos['months']"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="제조사" label-width="80px">
              <el-select v-model="form.maker">
                <el-option value=''  label="전체">==전체==</el-option>
                <el-option
                    v-for="item in combos['maker']"
                    :key="item.key"
                    :value="item.key"
                    :label="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="제품군" label-width="80px">
              <el-select v-model="form.itemGroup" style="width: 40%;">
                <el-option value='' label="전체">==전체==</el-option>
                <el-option
                    v-for="item in combos['modelGroup']"
                    :key="item.id"
                    :value="item"
                    :label="item.value">
                </el-option>
              </el-select>
              <el-select v-model="form.itemDetail" v-if="form.itemGroup != '' && combos['modelDetail'].length > 0" style="width: 50%;">
                <el-option value='' label="전체">==전체==</el-option>
                <el-option
                    v-for="item in combos['modelDetail']"
                    :key="item.key"
                    :value="item.key"
                    :label="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="품번" label-width="100px">
              <el-input type="text" v-model="form.itemCd" @keyup.native.enter="goOpen"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- 테이블 -->
    <div class="talbe-contain" style="display: flex">
      <div class="table-sub-contain"  style="width: 100%;">
        <div class="table-area">
          <div class="table-b">
            <ag-grid-vue
                ref="gridMain"
                style="width: 100%; height: 54vh; min-height: 25px;"
                class="ag-theme-alpine"
                rowSelection="multiple"


                :columnDefs="columnDefsMain"
                :defaultColDef="defaultColDefMain"
                :frameworkComponents="frameworkComponents"
                :rowData="mainData"
                :gridOptions="gridOptionsMain"
                :statusBar="statusBar"
                @cell-value-changed="valueChange"
                @grid-ready="onReadyMain"
            />
          </div>
        </div>



      </div> <!-- table sub contain -->
    </div> <!-- table contain -->
  </div>


</template>
<script>
import _ from "lodash";

import CheckboxCellRenderer from '@/components/agGrid/checkbox-cell-renderer';
import ButtonCellRenderer from '@/components/agGrid/button-cell-renderer';
import common from '@/mixin/common';
import ProgramInfo from '@/components/InfoManage/ProgramInfo.vue';
/* 검색 폼 컴포넌트 */
import SearchForm from '@/components/AS/SearchForm/index.vue';

/**
 * Url JOIN
 */
function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

export default {
  mixins: [common],
  name: "program",
  components: {ProgramInfo,SearchForm},
  data() {
    return {
      title: "",
      deleteid: "",
      deleteList: [],
      parentNm: "",
      parentId: "0",
      form: {
        years : this.$moment().format('YYYY'),
        months : this.$moment().format('MM'),
        programKey: "",
        programNm: "",
        programId: "",
        parentId: "",
        topKey: "",
        programIdx: "",
        description: "",
        startDt: new Date(),
        startDt2: new Date(),
        modelCd : "",
        maker : "",
        modelGroup : "",
        standardModelNm : "",
        modelNm : "",
        itemGroup : "",
        itemDetail: "",
      },
      defForm: {
        programKey: "",
        programNm: "",
        programId: "",
        parentId: "",
        topKey: "",
        programIdx: "",
        description: "",
        modelCd : "",
        maker : "",
        modelGroup : "",
        standardModelNm : "",
        modelNm : "",
      },
      combos: {
        'years': [], //년
        'months': [], //월
        'maker': [], //제조사
        'modelGroup': [], //제품군
        'modelDetail': [], //제품군 select,
      },
      data: [],
      mainData: [],
      subData: [],
      gridOptions: {
        //enableColResize: true,
        //enableFilter: true,
        //animateRows: false,
        //enableSorting: true
        rowModelType: 'serverSide',
      },
      gridOptionsMain: {
        //enableColResize: true,
        //enableFilter: true,
        //animateRows: false,
        //enableSorting: true
      },
      gridOptionsSub: {
        //enableColResize: true,
        //enableFilter: true,
        //animateRows: false,
        //enableSorting: true
      },
      defaultColDef: {
        resizable: true,
        filter: true,
        sortable: true,
        editable: true,
        width: 240,
        flex: 1,
      },
      defaultColDefMain: {
        resizable: true,
        filter: true,
        sortable: true,
        editable: true,
        //width: 240,
        //flex: 1,
        //cellStyle : {'justify-content': 'center','align-items': 'center', 'display': 'flex','height': '100%'}
      },
      defaultColDefSub: {
        resizable: true,
        filter: true,
        sortable: true,
        editable: true,
        //width: 240,
        //flex: 1,
        //cellStyle : {'justify-content': 'center','align-items': 'center', 'display': 'flex','height': '100%'}
      },
      programDetail: [],
      gridApi: null,
      columnApi: null,
      gridApiMain: null,
      columnApiMain: null,
      columnDefs: [],
      gridApiSub: null,
      columnApiSub: null,
      columnDefsMain: [],
      columnDefsSub: [],
      frameworkComponents: null,
      autoGroupColumnDef: null,
      rowModelType: null,
      isServerSideGroupOpenByDefault: null,
      isServerSideGroup: null,
      getServerSideGroupKey: null,
      submitList:[],
      modifyList:[],
      selectId: "",
    };
  },
  methods: {
    //메인그리드 Ready
    onReadyMain(params) {
      this.gridApiMain = this.gridOptionsMain.api;
      this.columnApiMain = this.gridOptionsMain.columnApi;
      this.gridApiMain.sizeColumnsToFit();
      // this.gridApiMain.autoSizeAllColumns();
      this.autoSizeAll(this.columnApiMain);
      this.init();

      this.$http
          .post("/api/workMng/monthStock/list", {
            companyId: this.$store.state.loginInfo.compCd,
            yyMm: this.form.years + this.form.months,
            maker: this.form.maker || '',
            itemGroup : this.GroupCheck(this.form.itemDetail),
            useModelNm: this.form.useModelNm || '',
            itemCd: this.form.itemCd || '',
            catId: 0,
            asAgentId: 0,
            sortType : '',
            page : 1,
            totalPage : 99999,
            totalCount : 1,
            curPage : 0,
            processTime: ""
          })
          .then(response => {
            this.mainData = response.data;
            console.log(response.data);
          }).finally(() => {
        this.autoSizeAll(this.gridApiMain);
      });

    },
    //서브그리드 Ready
    onReadySub(params) {
      //서브그리드 api 정의
      this.gridApiSub = this.gridOptionsSub.api;
      this.columnApiSub = this.gridOptionsSub.columnApi;
      this.gridApiSub.sizeColumnsToFit();
      // this.gridApiSub.autoSizeAllColumns();
      this.autoSizeAll(this.columnApiSub);
    },
    autoSizeAll(columnApi) {
      const allColumnIds = [];
      columnApi.columnController.gridColumns.forEach((column) => {
        allColumnIds.push(column.getId());
      });
      columnApi.columnController.autoSizeColumns(allColumnIds, false);
    },
    getCheckReadOnly(startDt){
      return startDt == null ? true : false;
    },
    //그리드컬럼 정의
    createColumnDefs() {
      const vm = this

      this.columnDefsMain = [
        {headerName: '제조사', field: 'makerNm', width: 150, editable: false},
        {headerName: '제품군', field: 'itemGroupNm', width: 150, editable: false},
        {headerName: '대표모델', field: 'useModelNm', width: 150, editable: false},
        {headerName: '품번', field: 'itemCd', width: 150, editable: false},
        {headerName: '품명', field: 'itemNm', width: 150, editable: false},
        {
          headerName: '양품',
          children: [
            {headerName:'전월', field:'preGoodQty', width:120, cellStyle:{textAlign: 'right'}},
            {headerName:'입고', field:'inGoodQty', width:120, cellStyle:{textAlign: 'right'}},
            {headerName:'출고', field:'outGoodQty', width:120, cellStyle:{textAlign: 'right'}},
            {headerName:'출고중', field:'outingGoodQty', width:120, cellStyle:{textAlign: 'right'}},
            {headerName:'당월', field:'invtGoodQty', width:120, cellStyle:{textAlign: 'right'}},
          ]
        },
        {
          headerName: '불량',
          children: [
            {headerName:'전월', field:'preBadQty', width:120, cellStyle:{textAlign: 'right'}},
            {headerName:'입고', field:'inBadQty', width:120, cellStyle:{textAlign: 'right'}},
            {headerName:'출고', field:'outBadQty', width:120, cellStyle:{textAlign: 'right'}},
            {headerName:'출고중', field:'outingBadQty', width:120, cellStyle:{textAlign: 'right'}},
            {headerName:'당월', field:'invtBadQty', width:120, cellStyle:{textAlign: 'right'}},
          ]
        }
      ];

    },
    //Tree 그리드 SelctionChange 발생
    valueChange(params) {
      console.log(params);
      this.initSub();
    },
    onSelectionChangedSub(event) {
      this.gridApiSub = this.gridOptionsSub.api;
      this.columnApiSub = this.gridOptionsSub.columnApi;
      const voRow = this.gridApiSub.getSelectedRows() //선택된 Row
      this.$http
          .post("/api/program/detail/sub", {
            companyId: this.$store.state.loginInfo.compCd,
            programId: voRow[0].programId,
            processTime: ""
          })
          .then(response => {
            if (response.data[0]) {
              this.programDetail = response.data[0];
            }
          }).finally(() => {
      });
    },
    goOpen() {
      this.$store.commit("loading");
      // list 재실행
      this.$http
          .post("/api/workMng/monthStock/list", {
            companyId: this.$store.state.loginInfo.compCd,
            yyMm: this.form.years + this.form.months,
            maker: this.form.maker || '',
            itemGroup : this.GroupCheck(this.form.itemDetail),
            useModelNm: this.form.useModelNm || '',
            itemCd: this.form.itemCd || '',
            catId: 0,
            asAgentId: 0,
            sortType : '',
            page : 1,
            totalPage : 99999,
            totalCount : 1,
            curPage : 0,
            processTime: ""
          })
          .then(response => {
            this.mainData = response.data;
          }).finally(() => {
            this.$store.commit("finish");
            this.autoSizeAll(this.gridApiMain);
          });

    },
    GroupCheck(modelCd) {
      let val = "";
      if(modelCd == undefined || modelCd == null || modelCd == ''){
        if(this.form.itemGroup.key != undefined){
          val = this.form.itemGroup.key;
        }
      }else{
        if(this.form.itemDetail != undefined){
          val = this.form.itemDetail;
        }
      }
      return val
    },
    save() {

      let submitList = this.subData;

      for(var i = 0; i < submitList.length; i ++){
        submitList[i].standDt = this.form.startDt;
      }

      this.$http.put('/api/materialsMng/standDt/save',submitList)
      .then(response => {
        this.$swal({ type: 'success', text: '수정되었습니다.' });
        this.subData = [];
        this.goOpen();
      })
      .catch(({ message }) => {
        if (message === "Request failed with status code 500") {
          this.$swal({ type: "error", text: "오류가 발생했습니다." });
        }
      });

    },
    chkNumber(params, flag, excRt){
      var result = '';
      var val = params.value;
      var data = this.data;

      if(flag === 'sub'){
        data = this.subData;
      }

      if(!_.isEmpty(val) || _.isNumber(val)){
        val = val.toString();

        if (excRt === 'excRt'){
          result = this.$numeral(val).format('0,0.00');
        } else {
          result = this.$numeral(val).format('0,0');
        }

        data[params.node.id][params.column.colId] = this.$numeral(val).value();
      }

      return result
    },
    //그리드 Cell 클릭 함수
    onCellClicked(event) {
      const idx = event.rowIndex;
      const field = event.colDef.field;
      const programId = event.data.programId;
    },

    deleteRow() {

      const grid = this.$refs.gridMain.rowData
      console.log(grid);
      const programId = grid[0].programId;

      this.$swal({
        type: 'info',
        text: `선택한 프로그램을 삭제하시겠습니까?`,
        showCancelButton: true,
        confirmButtonText: '예',
        cancelButtonText: '아니오',
      }).then((result) => {
        if (result.value) {
          this.$store.commit('loading')
          this.$http.delete(_url('/api/program/delete/' + this.$store.state.loginInfo.compCd  +'/'  + programId + '/' +this.$store.state.loginInfo.id ),
              {
                process_time: ""
              }).then(response => {
            if (response.data) {
              this.$swal({type: 'info', text: '삭제 완료 하였습니다.'});
            }
            this.goOpen();
          })
              .catch(({message}) => {
                console.error(message);
              }).finally(() => {
            this.$store.commit('finish')
          })
        }
      })

    },
    getDateFormat(val) {
      if (val) {
        return val === 'null' ? '' : this.$moment(val).format('YYYY-MM-DD')
      }
    },
    addRow() {
      this.data.push({
        compCd: this.$store.state.loginInfo.compCd,
      });
    },
    initSub() {
        const grid = this.$refs.gridMain;

        this.submitList = [];

        const chkDatas = grid.rowData.filter((x,i) => {
          return x.regYn === "1"
        })

        for(var i=0; chkDatas.length > i; i++){
          if(this.getCheckReadOnly(chkDatas[i].startDt)) continue;
          this.submitList.push({
            companyId: this.$store.state.loginInfo.compCd,
            maker: chkDatas[i].maker,
            makerNm: chkDatas[i].makerNm,
            useModelNm: chkDatas[i].useModelNm,
            description: chkDatas[i].description,
            itemId: chkDatas[i].itemId,
            itemCd: chkDatas[i].itemCd,
            itemNm: chkDatas[i].itemNm,
            itemSpec: chkDatas[i].itemSpec,
            itemGroup: chkDatas[i].itemGroup,
            itemGroupNm: chkDatas[i].itemGroupNm,
            itemPriceId: chkDatas[i].itemPriceId,
            unitPrice1: chkDatas[i].unitPrice1,
            unitPrice2: chkDatas[i].unitPrice2,
            unitPrice3: chkDatas[i].unitPrice3,
            unitPrice4: chkDatas[i].unitPrice4,
            unitPrice5: chkDatas[i].unitPrice5,
            unitPrice6: chkDatas[i].unitPrice6,
            unitPrice7: chkDatas[i].unitPrice7,
            unitPrice8: chkDatas[i].unitPrice8,
            unitPrice9: chkDatas[i].unitPrice9,
            unitPrice10: chkDatas[i].unitPrice10,
            creatorId: this.$store.state.loginInfo.id,
            processTime: ""
          });
        }

        this.subData = this.submitList;


    },
    async init() {
      this.$store.commit('loading');
      let [query, form] = await Promise.all([
        this.$http.post(`/api/materialsMng/init`,{
          parentId: this.form.itemGroup.id
        })
      ]).finally(() => {
        //this.goOpen();
        this.$store.commit('finish');
      });

      this.combos['years'] = query.data.years;
      this.combos['months'] = query.data.months;
      this.combos['maker'] = query.data.maker;
      this.combos['modelGroup'] = query.data.modelGroup;
      this.combos['modelDetail'] = query.data.modelDetail;
      // this.form = form.data;
    },
    cancel() {
      // programInfo 초기화
      this.goOpen();
    }
  },
  beforeMount() {

    this.createColumnDefs(); //그리드 컬럼정의 함수 호출

    this.frameworkComponents = {//그르드에서 사용할 외부 comp 등록
      checkboxRenderer: CheckboxCellRenderer,
      buttonCellRenderer: ButtonCellRenderer,
    };

  },
  mounted() {
    //this.goOpen();
  },
  created() {
    this.statusBar = {
      statusPanels: [
        { statusPanel: 'agTotalRowCountComponent', align: 'right' },
      ],
    };
  },
  watch:{
    'form.itemGroup'(){
      this.init();
    }
  }
}
</script>